module.exports = {
	"title": "DATABASE",
	"type": "object",
	"properties": {
		"general": {
			"type": "object",
			"title": "General",
			"properties": {
				"title": {
					"type": "string"
				},
				"description": {
					"type": "string"
				}
			}
		},
		"titles": {
			"type": "object",
			"title": "Titles",
			"properties": {
				"top": {
					"type": "string"
				},
				"projects": {
					"type": "string"
				},
				"archives": {
					"type": "string"
				},
				"about": {
					"type": "string"
				}
			}
		},
		"projects": {
			"type": "array",
			"format": "tabs",
			"title": "Projects",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Project",
				"headerTemplate": "{{ i1 }} - {{ self.title }}",
				"properties": {
					"id": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"extra": {
						"type": "string"
					},
					"live": {
						"type": "boolean"
					},
					"url": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"archives": {
			"type": "array",
			"format": "tabs",
			"title": "Archives",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Project",
				"headerTemplate": "{{ i1 }} - {{ self.title }}",
				"properties": {
					"id": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"live": {
						"type": "boolean"
					},
					"url": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"experience": {
			"type": "array",
			"format": "table",
			"title": "Experience",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Experience",
				"properties": {
					"date": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"location": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"education": {
			"type": "array",
			"format": "table",
			"title": "Education",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Education",
				"properties": {
					"date": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"about": {
			"type": "string",
			"format": "textarea"
		},
		"links": {
			"type": "array",
			"format": "table",
			"title": "Links",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Link",
				"properties": {
					"url": {
						"type": "string"
					},
					"label": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"modals": {
			"type": "array",
			"title": "Modals",
			"items": {
				"type": "object",
				"title": "Project",
				"headerTemplate": "{{ i1 }} - {{ self.title }}",
				"properties": {
					"id": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"sections": {
						"type": "array",
						"items": {
							"type": "object",
							"format": "grid",
							"title": "Section",
							"headerTemplate": "{{ i1 }} - {{ self.type }}",
							"properties": {
								"type": {
									"type": "string",
									"enum": [
										"image",
										"text",
										"slideshow",
										"embed"
									]
								},
								"value": {
									"type": "string"
								}
							}
						}
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/admin/schema.json
// module id = 164
// module chunks = 1